import CloseIcon from "@mui/icons-material/Close";
import { Col, Button } from "react-bootstrap";
import Modal from "@mui/material/Modal";
import { useState, useEffect, useContext } from "react";
import axios from "axios";
import { Avatar } from "@mui/material";
import Rating from "@mui/material/Rating";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Box from "@mui/material/Box";
import Toast from "react-bootstrap/Toast";
import React from "react";
import { AuthContext } from "../../../context/AuthContext";
import MONTHS from "../../../context/Months";
import { useParams } from "react-router-dom";
import FetchFingerprint from "../../../actions/FetchFingerprint";
import ENDPOINT from "../../../data/ENDPOINT";
import { Badge, GroupAdd, LibraryAdd, LocalLibrary, LocalLibraryOutlined } from "@mui/icons-material";
import { Library } from "lucide-react";
import DownhillSkiingTwoToneIcon from '@mui/icons-material/DownhillSkiingTwoTone';

const HobbiesList = () => {
  const params = useParams();
  const username = params.username;
  const { user } = useContext(AuthContext);

  const [title, settitle] = useState(null);
  const [education, seteducation] = useState(null); // list of hobbies
  const [level, setlevel] = useState(3);
  const [self, setself] = useState(false);
  const [addeducation, setaddeducation] = useState(false);
  const [edit, setedit] = useState(false);
  const [editid, seteditid] = useState(null);

  const [toast, settoast] = useState(false);
  const [toasttitle, settoasttitle] = useState(null);
  const [toastmessage, settoastmessage] = useState(null);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
  };

  const ClearData = () => {
    settitle(null);
    setlevel(3);
  };

  const Fetch_education = async () => {
    try {
      const formdata = new FormData();
      formdata.append("session", user.SessionId);
      formdata.append("fp", FetchFingerprint());
      formdata.append("username", username);
      const res = await axios.post(`${ENDPOINT}user-hobbies.php`, formdata, {
        headers: { "content-type": "multipart/form-data" },
      });
      if (res && res.data && res.data.status === "success") {
        seteducation(res.data.data);
        setself(res.data.self);
      }
    } catch (e) {
      // silent
    }
  };

  const SaveEducation = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append("session", user.SessionId);
      formData.append("fp", FetchFingerprint());
      formData.append("title", title);
      formData.append("level", level);
      const res = await axios.post(`${ENDPOINT}hobbies-add.php`, formData, {
        headers: { "content-type": "multipart/form-data" },
      });
      if (res && res.data && res.data.status === "success") {
        settoasttitle("Hobby added successfully");
        settoast(true);
        setaddeducation(false);
        ClearData();
        Fetch_education();
      }
    } catch (e) {
      // ignore
    }
  };

  const Edit = async ({ id, action, index }) => {
    try {
      const formdata = new FormData();
      formdata.append("session", user.SessionId);
      formdata.append("fp", FetchFingerprint());
      formdata.append("id", id);
      if (action === "get") {
        // populate fields from local list to avoid extra API when possible
        if (education && typeof index === "number") {
          settitle(education[index].title);
          setlevel(education[index].level);
        }
        seteditid(id);
        setedit(true);
        return;
      }
      // save edit
      formdata.append("title", title);
      formdata.append("level", level);
      const res = await axios.post(`${ENDPOINT}hobbies-edit.php`, formdata, {
        headers: { "content-type": "multipart/form-data" },
      });
      if (res && res.data && res.data.status === "success") {
        settoasttitle("Edit successful");
        settoast(true);
        setedit(false);
        ClearData();
        Fetch_education();
      }
    } catch (e) {
      // ignore
    }
  };

  const Delete = async ({ education_id }) => {
    try {
      const data = new FormData();
      data.append("id", education_id);
      data.append("session", user.SessionId);
      data.append("fp", FetchFingerprint());
      const res = await axios.post(`${ENDPOINT}hobbies-delete.php`, data, {
        headers: { "content-type": "multipart/form-data" },
      });
      if (res && res.data && res.data.status === "success") {
        settoasttitle("Deleted successfully");
        settoast(true);
        Fetch_education();
      }
    } catch (e) {
      // ignore
    }
  };

  useEffect(() => {
    Fetch_education();
  }, []);

  return (
    <>
      <div className="toast-container">
        <Toast
          className="bg-warning"
          onClose={() => settoast(false)}
          show={toast}
          delay={3000}
          autohide
        >
          <Toast.Header>
            <img
              src="holder.js/20x20?text=%20"
              className="rounded me-2"
              alt=""
            />
            <strong className="me-auto">{toasttitle}</strong>
          </Toast.Header>
          <Toast.Body>{toastmessage}</Toast.Body>
        </Toast>
      </div>

      <Modal open={edit} onClose={() => setedit(false)}>
        <Box className="col-lg-5 rounded col-md-5 col-sm-6 col-11" sx={style}>
          <div className="w-100">
            <div className="flex align-items-center space-between">
              <h4>Edit Hobby</h4>
              <CloseIcon type="button" onClick={() => setedit(false)} />
            </div>
            <hr />
            <form
              method="post"
              onSubmit={(e) => {
                e.preventDefault();
                Edit({ id: editid, action: "edit" });
              }}
            >
              <label className="mt-1 w-100 me-3">Hobby Name</label>
              <input
                required
                minLength={3}
                maxLength={30}
                className="form-control me-3"
                type="text"
                value={title || ""}
                onChange={(e) => settitle(e.target.value)}
                name="title"
              />
              <br />
              <label className="mt-1 w-100 me-3">Level</label>
              <div>
                <Rating
                  value={Number(level)}
                  onChange={(e, v) => setlevel(v)}
                />
              </div>
              <Button variant="btn btn-warning  w-100 mt-3" type="submit">
                Save Changes
              </Button>
            </form>
          </div>
        </Box>
      </Modal>

      <Modal open={addeducation} onClose={() => setaddeducation(false)}>
        <Box className="col-lg-5" sx={style}>
          <div className="w-100">
            <div className="flex align-items-center space-between">
              <h4>Add Hobby</h4>
              <CloseIcon type="button" onClick={() => setaddeducation(false)} />
            </div>
            <hr />
            <form method="post" onSubmit={SaveEducation}>
              <label className="mt-1 w-100 me-3">Hobby Name</label>
              <input
                required
                minLength={3}
                maxLength={30}
                className="form-control me-3"
                type="text"
                value={title || ""}
                onChange={(e) => settitle(e.target.value)}
                name="title"
              />
              <br />
              <label className="mt-1 w-100 me-3">Level</label>
              <div>
                <Rating
                  value={Number(level)}
                  onChange={(e, v) => setlevel(v)}
                />
              </div>
              <Button variant="btn btn-warning  w-100 mt-3" type="submit">
                Save Changes
              </Button>
            </form>
          </div>
        </Box>
      </Modal>

      {education ? (
        <>
          <div className="border br-5 sm-br-none sm-shadow-none p-3">
            <div className="flex space-between align-items-center experience-header">
              <h4
                style={{ color: "rgb(234 88 12)", fontWeight: 700 }}
                className="mb-3 pt-2"
              >
                Hobbies
              </h4>
              {self ? (
                <>
                  <button
                    style={{ background: "rgb(234 88 12)", color: "#ffffff" }}
                    type="button"
                    onClick={() => setaddeducation(true)}
                    className="btn add-experience-btn fw-bold shadow-sm"
                  >
                    ADD
                  </button>
                </>
              ) : null}
            </div>

            <Col lg={12} md={12} sm={12} xs={12} className=" rounded p-3 ">
              {education && Array.isArray(education) && education.length > 0 ? (
                <>
                  {education.map((edu, index) => (
                    <div key={edu.id} className="mt-3 mb-3">
                      <div
                        style={{
                          border: "1px solid #f5e3d6",
                          borderRadius: "12px",
                          padding: "16px",
                          backgroundColor: "#fff",
                        }}
                      >
                        <div
                          className="flex space-between align-items-start"
                          style={{ flexWrap: "wrap", gap: "12px" }}
                        >
                        <div
                                                      className="skill-icon"
                                                      style={{
                                                        width: 56,
                                                        height: 56,
                                                        borderRadius: "50%",
                                                        backgroundColor: "rgba(255,165,0,0.18)",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        marginRight: 14,
                                                        flexShrink: 0,
                                                      }}
                                                    >
                                                      <DownhillSkiingTwoToneIcon
                                                        style={{ color: "orange", fontSize: 28 }}
                                                      />
                                                    </div>
 <div style={{ minWidth: 0, flex: 1 }}>
                              <h5
                                style={{
                                  margin: "0 0 8px 0",
                                  fontWeight: 700,
                                  color: "#292929",
                                  fontSize: "18px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {edu.title}
                              </h5>
                              <div style={{ marginBottom: "8px" }}>
                                <Rating
                                  style={{
                                    margin: "6px 0 4px",
                                    color: "rgb(234 88 12)",
                                  }}
                                  name={`rating-${edu.id}`}
                                  value={edu.level}
                                  size="small"
                                  readOnly
                                />
                              </div>
                              <p
                                style={{
                                  margin: "0",
                                  fontSize: "14px",
                                  color: "#585f65",
                                }}
                              >
                                {edu.level === 1
                                  ? "Beginner"
                                  : edu.level === 2
                                    ? "Intermediate"
                                    : edu.level === 3
                                      ? "Average"
                                      : edu.level === 4
                                        ? "Better"
                                        : "Best"}
                              </p>
                            </div>
                          <div
                            className="flex flex-column align-items-end experience-card-actions"
                            style={{
                              marginLeft: "12px",
                              textAlign: "center",
                              minWidth: "80px",
                            }}
                          >
                            {self ? (
                              <>
                                <div
                                  style={{
                                    marginBottom: "12px",
                                    display: "flex",
                                    gap: "12px",
                                    flexWrap: "wrap",
                                    justifyContent: "flex-end",
                                  }}
                                >
                                  <button
                                    type="button"
                                    style={{
                                      width: "44px",
                                      height: "44px",
                                      border: "2px solid #ff9800",
                                      borderRadius: "8px",
                                      backgroundColor: "#fff",
                                      cursor: "pointer",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      transition: "all 0.2s",
                                    }}
                                    onClick={() =>
                                      Edit({ id: edu.id, action: "get", index })
                                    }
                                    aria-label="edit"
                                  >
                                    <EditIcon
                                      style={{
                                        fontSize: "20px",
                                        color: "#ff9800",
                                      }}
                                    />
                                  </button>
                                  <button
                                    type="button"
                                    style={{
                                      width: "44px",
                                      height: "44px",
                                      border: "2px solid #dc3545",
                                      borderRadius: "8px",
                                      backgroundColor: "#fff",
                                      cursor: "pointer",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      transition: "all 0.2s",
                                    }}
                                    onClick={() =>
                                      Delete({ education_id: edu.id })
                                    }
                                    aria-label="delete"
                                  >
                                    <DeleteIcon
                                      style={{
                                        fontSize: "20px",
                                        color: "#dc3545",
                                      }}
                                    />
                                  </button>
                                </div>
                              </>
                            ) : null}
                            {/* <small
                              style={{ color: "#9ca3af", fontSize: "12px" }}
                            >
                              Best
                            </small> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </>
              ) : (
                <>
                  {self ? (
                    <>
                      {!education || education.length === 0 ? (
                        <div
                          onClick={() => setaddeducation(true)}
                          type="button"
                          className="flex text-primary align-items-center"
                        >
                          <AddIcon className="mr-2" />
                          <h6 className="mb-0">Add Hobby</h6>
                        </div>
                      ) : null}
                    </>
                  ) : null}
                </>
              )}
            </Col>
          </div>
        </>
      ) : (
        <>
          <div className="border br-5 sm-br-none text-center mt-5 p-3">
            <div className="flex space-between align-items-center">
              {/* <h4 className="mb-3 pt-2">Hobbies</h4> */}
              {self ? (
             <></>
              ) : null}
            </div>
            {self ? (
              <div className="container empty-profile-section ">
                <h4
                  onClick={() => setaddeducation(true)}
                  className="btn rounded-pill btn-outline-secondary"
                >
                  Add a hobby
                </h4>
              </div>
            ) : (
              <div className="text-center">
                <h5 className="text-secondary">No Hobby Added</h5>
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default HobbiesList;